// src/services/stokAwalAPI.js
//
// Stok Awal Tahun — diinput manual user, disimpan di DB gapintegrity via gapfamily.
// Tidak ada sumber otomatis di Accurate/produksi, jadi kita pakai tabel sendiri.

import { gapfamilyApi } from './api';
import { TENANTS } from './sursysLogisticAPI';

const companyId = () => TENANTS.SUMA.company_id;
const unwrap = (data) => data?.data ?? data;

// Ambil stok awal untuk satu tahun → map { kode: qty } (cabang='' / nasional).
export const fetchStokAwal = async (tahun) => {
  try {
    const { data } = await gapfamilyApi.get('/stok-awal', { params: { company_id: companyId(), tahun } });
    const rows = unwrap(data) || [];
    const map = {};
    rows.forEach((r) => { if (!r.cabang) map[r.kode] = Number(r.qty) || 0; });
    return map;
  } catch (e) {
    console.error('fetchStokAwal', e);
    return {};
  }
};

// Simpan satu nilai stok awal (upsert). cabang default '' = nasional.
export const saveStokAwal = async ({ kode, tahun, qty, cabang = '' }) => {
  try {
    await gapfamilyApi.post('/stok-awal', { company_id: companyId(), kode, tahun, qty, cabang });
    return true;
  } catch (e) {
    console.error('saveStokAwal', e);
    return false;
  }
};
